"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const particles = Array.from({
  length: 40
}).map((_, i) => ({
  id: i,
  x: `${(i * 7 + 13) % 100}%`,
  y: `${(i * 11 + 17) % 100}%`,
  size: `${i % 3 + 1}px`,
  duration: `${10 + i % 15}s`,
  delay: `${i % 10 * -1}s`,
  opacity: (i % 5 + 2) / 10
}));
export default function FuturisticHero() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="futuristichero" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[var(--color-terrigma-black)]">
      {}
      <style dangerouslySetInnerHTML={{
      __html: `
          @keyframes float-particle {
            0% { transform: translateY(0) translateX(0); opacity: 0; }
            20% { opacity: var(--particle-opacity); }
            80% { opacity: var(--particle-opacity); }
            100% { transform: translateY(-20vh) translateX(5vw); opacity: 0; }
          }
          .animate-float-particle {
            animation: float-particle linear infinite;
          }
        `
    }} />

      {}
      <div className="absolute inset-0 bg-gradient-to-b from-[#2A1A0A]/40 via-[var(--color-terrigma-black)] to-[var(--color-terrigma-purple)]/20 pointer-events-none" />

      {}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {particles.map((p, i) => <div key={p.id} data-index={i} className="absolute rounded-full bg-[var(--color-terrigma-gold)] animate-float-particle blur-[1px]" style={{
        left: p.x,
        top: p.y,
        width: p.size,
        height: p.size,
        animationDuration: p.duration,
        animationDelay: p.delay,
        '--particle-opacity': p.opacity
      } as React.CSSProperties} />)}
      </div>

      {}
      <div ref={contentRef} className={`relative z-10 container mx-auto px-4 md:px-6 flex flex-col items-center text-center transition-all duration-1000 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <h1 className="font-serif text-5xl sm:text-6xl md:text-8xl lg:text-9xl font-bold text-[var(--color-terrigma-gold)] uppercase tracking-widest mb-6 drop-shadow-[0_0_20px_rgba(196,138,58,0.3)]">
          TERRIGMA
        </h1>
        
        <p className="font-default text-xl md:text-2xl lg:text-3xl italic text-[var(--color-terrigma-offwhite)] mb-8 font-medium tracking-wide">
          Dig the World. Collect the Earth.
        </p>
        
        <p className="font-default text-base md:text-lg lg:text-xl text-[var(--color-terrigma-lavender)] max-w-3xl mb-12 leading-relaxed opacity-90">
          The world's first mobile soil science exploration game. Players excavate, identify, and collect scientifically accurate soil profiles from all 195 countries, powered by real FAO and ISRIC earth science data.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 w-full sm:w-auto">
          <Link to="#" className="w-full sm:w-auto">
            
          </Link>
          
          <Link to="#" className="w-full sm:w-auto">
            
          </Link>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[var(--color-terrigma-black)] to-transparent pointer-events-none" />
    </section>;
}